import BaseApi from '../BaseApi';
// 站点左侧接口
export default class BatteryHolderApi extends BaseApi {
  // ***************************电池信息begin***************************
  // 1.电池信息
  async selectBatteryDetail(info) {
    return await this.get(`screenBatteryInfo/selectBatteryDetail`, info);
  }
  // 2.获取电池月换电次数
  async selectBatteryChangePowerNum(info) {
    return await this.get(`screenBatteryInfo/selectBatteryChangePowerNum`, info);
  }
  // ***************************电池信息end***************************
  // ***************************成本分析begin***************************
  // 3.获取电池成本分析
  async selectBatteryCostAnalyst(info) {
    return await this.get(`screenBatteryInfo/selectBatteryCostAnalyst`, info);
  }
  // 4.获取电池成本变化趋势
  async selectBatteryCostCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryCostCurrent`, info);
  }
  // 5.获取电池收入变化趋势
  async selectBatteryRcvCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryRcvCurrent`, info);
  }
  // 6.获取电池利润变化趋势
  async selectBatteryProfitCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryProfitCurrent`, info);
  }
  // ***************************成本分析end***************************
  // ***************************性能分析begin***************************
  // 7.获取电池健康测评度趋势
  async selectBatteryHealthCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryHealthCurrent`, info);
  }
  // 8.获取电池衰减测评度趋势
  async selectBatteryDecayCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryDecayCurrent`, info);
  }
  // 16.获取温度电流电压检测信息
  async selectBatteryDetectionInfo(info) {
    return await this.get(`screenBatteryInfo/selectBatteryDetectionInfo`, info);
  }
  // 9.获取电池度电里程趋势
  async selectBatteryMileageCurrent(info) {
    return await this.get(`screenBatteryInfo/selectBatteryMileageCurrent`, info);
  }
  // ***************************性能分析end***************************
  // ***************************充电仓begin***************************
  // 10.获取电池仓基本信息
  async selectBatteryCompartmentInfo(info) {
    return await this.get(`screenBatteryInfo/selectBatteryCompartmentInfo`, info);
  }
  // ***************************充电仓end***************************
  
  // 根据站点获取电池集合列表
  async selectBatteryList(info) {
    return await this.get(`screenBatteryInfo/selectBatteryList`, info);
  }
  

}
export const batteryHolderLeft = new BatteryHolderApi();